export const newsList = [
  {
    id: "n001",
    title: "《长安十二时》口碑爆棚，古装悬疑再迎高光时刻",
    summary:
      "上线首周即登顶热度榜，紧凑的十二时辰叙事与考究的盛唐美学收获大量好评，被观众称为近年难得一见的古装悬疑佳作。",
    date: "2024-10-14",
    category: "剧集资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20grand%20ancient%20Chinese%20palace%20courtyard%20lit%20by%20warm%20lanterns%20at%20dusk%2C%20rich%20crimson%20and%20gold%20tones%2C%20cinematic%20depth%20of%20field%2C%20elegant%20period%20atmosphere&width=640&height=400&seq=news-n001&orientation=landscape",
  },
  {
    id: "n002",
    title: "科幻巨制《星际远征》曝幕后花絮，视效团队揭秘虫洞诞生",
    summary:
      "片方发布全新幕后特辑，展示虫洞与深空场景的制作过程。导演表示，希望用最真实的物理质感，讲述一个关于回家的故事。",
    date: "2024-10-12",
    category: "电影资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20editorial%20shot%20of%20a%20movie%20visual%20effects%20studio%20with%20glowing%20blue%20space%20simulation%20on%20large%20monitors%2C%20technical%20cinematic%20atmosphere%2C%20cool%20tones&width=640&height=400&seq=news-n002&orientation=landscape",
  },
  {
    id: "n003",
    title: "本周热播榜出炉：《迷雾侦探》稳居前三，悬疑题材持续升温",
    summary:
      "本周热播榜更新，悬疑推理类作品整体表现亮眼。观众对强情节、高密度反转剧集的偏好愈发明显，平台方也在加速布局该赛道。",
    date: "2024-10-10",
    category: "行业观察",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20foggy%20harbor%20town%20at%20dawn%20with%20warm%20street%20lamps%2C%20mysterious%20teal%20mist%2C%20cinematic%20wide%20composition%2C%20moody%20atmosphere&width=640&height=400&seq=news-n003&orientation=landscape",
  },
  {
    id: "n004",
    title: "《味觉之旅》收官特辑：一口烟火，一段归途",
    summary:
      "美食纪实综艺《味觉之旅》迎来收官，节目以食物为线索串起一个个普通人的故事，被观众评价为\"最下饭也最治愈\"的节目。",
    date: "2024-10-08",
    category: "综艺资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20food%20photography%20of%20steaming%20home%20style%20dishes%20on%20a%20rustic%20table%2C%20amber%20and%20terracotta%20tones%2C%20soft%20natural%20light%2C%20cozy%20cinematic%20mood&width=640&height=400&seq=news-n004&orientation=landscape",
  },
  {
    id: "n005",
    title: "古装剧集市场回暖，多部精品项目官宣定档",
    summary:
      "近期多部古装剧集官宣定档，题材涵盖权谋、传奇与奇幻。业内认为，制作水准的整体提升正在重新赢回观众对古装题材的期待。",
    date: "2024-10-06",
    category: "剧集资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20editorial%20photo%20of%20traditional%20Chinese%20silk%20robes%20and%20embroidered%20fabric%20displayed%20in%20soft%20studio%20light%2C%20rose%20and%20jade%20green%20tones%2C%20refined%20oriental%20aesthetic&width=640&height=400&seq=news-n005&orientation=landscape",
  },
  {
    id: "n006",
    title: "科幻题材持续升温，流媒体加码未来叙事",
    summary:
      "随着《未来纪元》等作品走红，科幻题材成为流媒体平台重点投入方向。平台方透露，未来将有更多中小成本、高概念的科幻作品上线。",
    date: "2024-10-04",
    category: "行业观察",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20editorial%20photo%20of%20a%20neon%20lit%20city%20skyline%20at%20night%20with%20reflections%20on%20wet%20streets%2C%20cyan%20and%20magenta%20glow%2C%20cinematic%20sci%20fi%20atmosphere&width=640&height=400&seq=news-n006&orientation=landscape",
  },
];